// frontend/src/components/forms/ManualBoxLineForm.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  canRegisterManualLine,
  manualLinePayload,
} from '../../utils/manualBoxLine';

export default function ManualBoxLineForm({
  sessionDate,
  control,
  onSuccess,
  editingRecord,
  clearEditing,
}) {
  const [closeBox, setCloseBox] = useState('');
  const [isTop, setIsTop] = useState(true);
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    setCloseBox(editingRecord?.close_box ?? '');
    setIsTop(editingRecord?.is_top ?? true);
    setMessage('');
  }, [editingRecord?.id, sessionDate]);

  const canEdit =
    !editingRecord ||
    (!editingRecord.strategy &&
      Date.parse(editingRecord.timestamp_korean_box) >=
        Date.parse(control?.session_start) &&
      Date.parse(editingRecord.timestamp_korean_box) <
        Date.parse(control?.session_end));
  const allowed = canRegisterManualLine(control, sessionDate) && canEdit;

  async function handleSubmit(e) {
    e.preventDefault();
    if (pending || !allowed || !canRegisterManualLine(control, sessionDate))
      return;
    setPending(true);
    setMessage('');
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    };
    const payload = manualLinePayload(sessionDate, closeBox, isTop);
    try {
      if (editingRecord) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/boxlines/manual/${editingRecord.id}`,
          { close_box: payload.close_box, is_top: payload.is_top },
          config,
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/boxlines/manual`,
          payload,
          config,
        );
      }
      setCloseBox('');
      setMessage('저장되었습니다.');
      clearEditing?.();
      onSuccess?.();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setMessage(
        detail?.message ||
          (typeof detail === 'string'
            ? detail
            : '저장에 실패했습니다. 입력값과 현재 세션을 확인해 주세요.'),
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <section className='my-6 text-left'>
      <h2 className='text-xl font-semibold mb-3'>변곡 매매 라인 입력</h2>
      <form onSubmit={handleSubmit}>
        <fieldset
          disabled={!allowed || pending}
          className='flex flex-wrap items-center gap-4 disabled:opacity-50'
        >
          <label>
            지수
            <input
              className='ml-2 w-40 rounded border px-2 py-1 text-neutral-900'
              type='number'
              step='0.25'
              min='0.25'
              value={closeBox}
              onChange={(e) => setCloseBox(e.target.value)}
              required
            />
          </label>
          <label className='inline-flex items-center gap-2'>
            <input
              type='radio'
              name='topBottom'
              checked={isTop}
              onChange={() => setIsTop(true)}
            />
            상단
          </label>
          <label className='inline-flex items-center gap-2'>
            <input
              type='radio'
              name='topBottom'
              checked={!isTop}
              onChange={() => setIsTop(false)}
            />
            하단
          </label>
          <button
            type='submit'
            className='rounded bg-sky-600 px-5 py-2 text-white disabled:opacity-40'
          >
            {pending ? '저장 중…' : editingRecord ? '수정 저장' : '등록'}
          </button>
        </fieldset>
        {editingRecord && (
          <button
            type='button'
            onClick={clearEditing}
            className='mt-2 underline'
          >
            편집 취소
          </button>
        )}
      </form>
      {!allowed && (
        <p className='mt-2 text-sm'>
          허용된 관리자는 현재 거래 세션에서 등록할 수 있습니다. 연결 전략이
          있는 라인은 수정할 수 없습니다.
        </p>
      )}
      {message && (
        <p role='status' className='mt-2'>
          {message}
        </p>
      )}
    </section>
  );
}
